import Vue from 'vue'
import App from './App.vue'
import router from './route'
import vuetify from './plugins/vuetify'
import VueObserveVisibility from 'vue-observe-visibility'
import searchableSelect from './components/searchableSelect'
import popupDrawer from './components/popupDrawer.vue'
import modulePrefix from './components/modulePrefix.vue'
import addNewOption from './components/addNewOption.vue'

import './utils/globalMixin.js'
import './utils/define.js'
import './utils/axiosInterceptor.js'

Vue.config.productionTip = false
Vue.use(VueObserveVisibility)
Vue.component('searchable-select', searchableSelect)
Vue.component('popup-drawer', popupDrawer)
Vue.component('module-prefix', modulePrefix)
Vue.component('add-new-option', addNewOption)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
